import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { AuthService } from '../_services/auth.service'
import { environment } from '../../environments/environment';

@Injectable()
export class ScriptingService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  //Scripting info
  getScriptingInfo(scripting_type,agentId) {
    return this._http.get(environment.va_service_api + "scripting/" + agentId +"/"+scripting_type  + "/info")
  }
    //Scripting fnction
    getScriptingFunctions(agentId) {
      return this._http.get(environment.va_service_api + "scripting/" + agentId +"/nlp_functions")
    }
    //VAScripting fnction
    getVAScriptingFunctions(agentId) {
      return this._http.get(environment.va_service_api + "scripting/" + agentId +"/va_functions")
    }

    // General Scripting Function
    getScriptingHelperFunctionInfo(agentId, type){
      return this._http.get(environment.va_service_api + "scripting/" + agentId + "/helper_functions/" + type)
    }

  // update scripting status
  updateScriptingStatus(scripting_type,agentId, params) {
    return this._http.post(environment.va_service_api + "scripting/" + agentId +"/"+ scripting_type + "/status", params)
  }

  // update script
  updateScript(scripting_type,agentId, params) {
    return this._http.post(environment.va_service_api + "scripting/" + agentId +"/"+ scripting_type + "/upsert", params)
  }
  // update script
  executeScript(agentId, params) {
    return this._http.post(environment.launched_test_api + agentId +"/MultiAgentSystem/meta/debug_nlp", params)
  }

    // update script
    executeNodeScript(agentId, params) {
      return this._http.post(environment.launched_test_api + agentId +"/MultiAgentSystem/meta/debug_node", params)
    }

  

  

    // update script
    // executeScript(agentId, params) {
    //   return this._http.post(environment.launched_test_api + agentId +"/MultiAgentSystem/meta/debug_nlp", params)
    //     .map((response) => {
    //       return response;
    //     },
    //       (err: Response) => {
    //         console.log(err);
    //       });
    // }

}
